import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Définit le titre et la meta description de la page (SPA).
 * Googlebot exécute le JS, donc il lit bien ces valeurs par page.
 */
export function useSeo(title: string, description?: string) {
  const { pathname } = useLocation()
  useEffect(() => {
    const canonical = document.head.querySelector('link[rel="canonical"]')
    const url = "https://www.maisongilles.be" + (pathname.replace(/\/$/, "") || "/")
    canonical?.setAttribute("href", url)
    document.head.querySelector('meta[property="og:url"]')?.setAttribute("content", url)
    if (title) document.title = title
    if (description) {
      let tag = document.head.querySelector('meta[name="description"]')
      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('name', 'description')
        document.head.appendChild(tag)
      }
      tag.setAttribute('content', description)
    }
  }, [title, description, pathname])
}
